var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-container",
    { staticClass: "exam-add" },
    [
      _c(
        "el-main",
        [
          _c("DsfVirtualScroll", [
            _c(
              "div",
              { staticClass: "exam-add-main" },
              [
                _c("div", { staticClass: "exam-add-header" }, [
                  _c("h1", [_vm._v(_vm._s(_vm.title))]),
                ]),
                _c(
                  "el-form",
                  {
                    ref: "ruleForm",
                    staticClass: "demo-ruleForm",
                    attrs: {
                      model: _vm.examQuestions,
                      rules: _vm.rules,
                      "label-width": "90px",
                    },
                    on: { validate: _vm.validateQuestions },
                  },
                  [
                    _c("div", { staticClass: "exam-select" }, [
                      _c(
                        "div",
                        { ref: "items", staticClass: "select-item" },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "items", label: "试题类型 :" } },
                            [
                              !_vm.readOnly
                                ? _c(
                                    "el-select",
                                    {
                                      attrs: {
                                        placeholder: "请选择",
                                        disabled: _vm.disabledItem,
                                      },
                                      on: { change: _vm.changeItem },
                                      model: {
                                        value: _vm.examQuestions.items,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.examQuestions,
                                            "items",
                                            $$v
                                          )
                                        },
                                        expression: "examQuestions.items",
                                      },
                                    },
                                    _vm._l(_vm.itemsData, function (item) {
                                      return _c("el-option", {
                                        key: item.value,
                                        attrs: {
                                          label: item.text,
                                          value: item,
                                        },
                                      })
                                    }),
                                    1
                                  )
                                : _c(
                                    "div",
                                    { staticClass: "ds-form-readonly" },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "proxy-text" },
                                        [
                                          _vm.examQuestions.items
                                            ? _c(
                                                "span",
                                                { staticClass: "proxy-conent" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.examQuestions.items
                                                        .text
                                                    )
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      ),
                                    ]
                                  ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { ref: "difficulty", staticClass: "select-item" },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                prop: "difficulty",
                                label: "试题难度 :",
                              },
                            },
                            [
                              !_vm.readOnly
                                ? _c(
                                    "el-select",
                                    {
                                      attrs: { placeholder: "请选择" },
                                      model: {
                                        value: _vm.examQuestions.difficulty,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.examQuestions,
                                            "difficulty",
                                            $$v
                                          )
                                        },
                                        expression: "examQuestions.difficulty",
                                      },
                                    },
                                    _vm._l(_vm.difficultyData, function (item) {
                                      return _c("el-option", {
                                        key: item.value,
                                        attrs: {
                                          label: item.text,
                                          value: item,
                                        },
                                      })
                                    }),
                                    1
                                  )
                                : _c(
                                    "div",
                                    { staticClass: "ds-form-readonly" },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "proxy-text" },
                                        [
                                          _vm.examQuestions.difficulty
                                            ? _c(
                                                "span",
                                                { staticClass: "proxy-conent" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.examQuestions
                                                        .difficulty.text
                                                    )
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      ),
                                    ]
                                  ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          ref: "types",
                          staticClass: "select-item exam-labels",
                        },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "types", label: "试题分类 :" } },
                            [
                              _c("DsfDataChoice", {
                                attrs: {
                                  readOnly: _vm.readOnly,
                                  dialogUrl: "exam/questions/types/choose",
                                  label: "试题分类",
                                  showLabel: false,
                                },
                                model: {
                                  value: _vm.examQuestions.types,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.examQuestions, "types", $$v)
                                  },
                                  expression: "examQuestions.types",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          ref: "labels",
                          class: [
                            "select-item",
                            "exam-labels",
                            {
                              "exam-labels-2":
                                _vm.examQuestions.labels &&
                                _vm.examQuestions.labels.length > 1 &&
                                !_vm.readOnly,
                            },
                          ],
                        },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "labels", label: "试题标签 :" } },
                            [
                              _c("DsfDataChoice", {
                                attrs: {
                                  readOnly: _vm.readOnly,
                                  dialogUrl: "exam/labels/choose",
                                  label: "试题标签",
                                  showLabel: false,
                                },
                                model: {
                                  value: _vm.examQuestions.labels,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.examQuestions, "labels", $$v)
                                  },
                                  expression: "examQuestions.labels",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]),
                    _c(
                      "div",
                      { ref: "name", staticClass: "question-item" },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "title-box",
                            attrs: { slot: "label" },
                            slot: "label",
                          },
                          [
                            _c("span", { staticClass: "line-name" }, [
                              _vm._v("题干"),
                            ]),
                            !_vm.readOnly
                              ? _c(
                                  "span",
                                  { staticClass: "line-dec" },
                                  [
                                    _vm._v("请在下方输入框填写题干描述 "),
                                    _vm.examQuestions["items"] &&
                                    _vm.examQuestions["items"].value == "input"
                                      ? _c(
                                          "el-button",
                                          {
                                            staticClass: "insert-blank",
                                            on: {
                                              click: function ($event) {
                                                return _vm.insertBlank()
                                              },
                                            },
                                          },
                                          [_vm._v(" 插入填空 ")]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ]
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { prop: "name", label: " " } },
                          [
                            _vm.readOnly
                              ? _c("div", {
                                  staticClass: "readonly-name",
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.examName(_vm.examQuestions)
                                    ),
                                  },
                                  on: { click: _vm.showImage },
                                })
                              : _c("DsfUEditor", {
                                  ref: "names",
                                  attrs: {
                                    richTxtHeight: 200,
                                    readOnly: _vm.readOnly,
                                    showLabel: false,
                                    readOnlyAutoHeight: true,
                                    toolBar: _vm.toolBar,
                                  },
                                  model: {
                                    value: _vm.examQuestions.name,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.examQuestions, "name", $$v)
                                    },
                                    expression: "examQuestions.name",
                                  },
                                }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm.examQuestions.items
                      ? _c(_vm.componentIs[_vm.examQuestions.items.value], {
                          ref: "questions_options",
                          tag: "component",
                          attrs: {
                            itemsData: _vm.itemsData,
                            difficultyData: _vm.difficultyData,
                            groupSubData: _vm.examQuestions["groupSubData"],
                            exam_questions_options:
                              _vm.examQuestions["exam_questions_options"],
                            readOnly: _vm.readOnly,
                          },
                          on: {
                            "set-ueditorids": _vm.setUeditorIds,
                            "add-show-image": _vm.elimage,
                            "add-judge": _vm.addjudge,
                          },
                        })
                      : _vm._e(),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.examQuestions.items &&
                              _vm.examQuestions.items.value !== "group",
                            expression:
                              "examQuestions.items && examQuestions.items.value !== 'group'",
                          },
                        ],
                        ref: "hint",
                        staticClass: "question-item",
                      },
                      [
                        _c("div", { staticClass: "title-box" }, [
                          _c("span", { staticClass: "line-name" }, [
                            _vm._v("提示"),
                          ]),
                          !_vm.readOnly
                            ? _c("span", { staticClass: "line-dec" }, [
                                _vm._v("请在下方框内填写提示"),
                              ])
                            : _vm._e(),
                        ]),
                        _c(
                          "el-form-item",
                          { attrs: { prop: "hint", label: " " } },
                          [
                            _vm.readOnly
                              ? _c("div", {
                                  staticClass: "readonly-name",
                                  domProps: {
                                    innerHTML: _vm._s(_vm.examQuestions.hint),
                                  },
                                  on: { click: _vm.showImage },
                                })
                              : _c("DsfUEditor", {
                                  ref: "hints",
                                  attrs: {
                                    richTxtHeight: 200,
                                    readOnly: _vm.readOnly,
                                    showLabel: false,
                                    readOnlyAutoHeight: true,
                                    toolBar: _vm.toolBar,
                                  },
                                  model: {
                                    value: _vm.examQuestions.hint,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.examQuestions, "hint", $$v)
                                    },
                                    expression: "examQuestions.hint",
                                  },
                                }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.examQuestions.items &&
                              _vm.examQuestions.items.value !== "group",
                            expression:
                              "examQuestions.items && examQuestions.items.value !== 'group'",
                          },
                        ],
                        ref: "parse",
                        staticClass: "question-item",
                      },
                      [
                        _c("div", { staticClass: "title-box" }, [
                          _c("span", { staticClass: "line-name" }, [
                            _vm._v("解析"),
                          ]),
                          !_vm.readOnly
                            ? _c("span", { staticClass: "line-dec" }, [
                                _vm._v("请在下方框内填写答案解析"),
                              ])
                            : _vm._e(),
                        ]),
                        _c(
                          "el-form-item",
                          { attrs: { prop: "parse", label: " " } },
                          [
                            _vm.readOnly
                              ? _c("div", {
                                  staticClass: "readonly-name",
                                  domProps: {
                                    innerHTML: _vm._s(_vm.examQuestions.parse),
                                  },
                                  on: { click: _vm.showImage },
                                })
                              : _c("DsfUEditor", {
                                  ref: "parses",
                                  attrs: {
                                    richTxtHeight: 200,
                                    readOnly: _vm.readOnly,
                                    showLabel: false,
                                    readOnlyAutoHeight: true,
                                    toolBar: _vm.toolBar,
                                  },
                                  model: {
                                    value: _vm.examQuestions.parse,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.examQuestions, "parse", $$v)
                                    },
                                    expression: "examQuestions.parse",
                                  },
                                }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm.srcList && _vm.srcList.length > 0
                  ? _c("el-image", {
                      ref: "elimage",
                      staticClass: "elimage",
                      attrs: { "preview-src-list": _vm.srcList },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _c(
        "el-footer",
        [
          !_vm.readOnly
            ? _c(
                "DsfButton",
                {
                  on: {
                    click: function ($event) {
                      return _vm.saveQestion("ruleForm")
                    },
                  },
                },
                [_vm._v("保存")]
              )
            : _vm._e(),
          _c(
            "DsfButton",
            { attrs: { type: "plain" }, on: { click: _vm.closePage } },
            [_vm._v("关闭")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }